import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { ACCESS_TOKEN_LOCAL_STORAGE_KEY, REFRESH_TOKEN_LOCAL_STORAGE_KEY } from "../contexts/AuthContext";
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const host = new URL(window.location.href);
const baseURL = host.origin;
const axiosInstance = axios.create({
    baseURL: baseURL, // Replace with your Django backend URL
    withCredentials: true, // Ensure cookies are sent with requests
});
const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp) {
            return (currentTime - decoded.exp) > 0;
        }
        throw new Error("Token does not have an expiry date");
    }
    catch (error) {
        console.error("Invalid token:", error);
        return true; // Treat invalid tokens as expired
    }
};
const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
    if (refreshToken) {
        try {
            const response = await axios.post('/api/auth/token/refresh/', {
                headers: {
                    'Content-Type': 'application/json',
                    'x-csrftoken': getCookie('csrftoken')
                },
                refresh: refreshToken
            });
            console.log("Refreshed JWTs:", response.data);
            return response.data;
        }
        catch (error) {
            console.error('Error refreshing access token:', error);
            return {};
        }
    }
    else {
        console.error('Refresh token not available.');
    }
};
axiosInstance.interceptors.request.use(async (config) => {
    const csrfToken = getCookie('csrftoken');
    let accessToken = localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
    if (accessToken) {
        if (isTokenExpired(accessToken)) {
            const tokens = await refreshAccessToken();
            if (!!tokens.access && !!tokens.refresh) {
                localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, tokens.access);
                localStorage.setItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY, tokens.refresh);
            }
            accessToken = tokens.access;
        }
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
    }
    if (timezone) {
        config.headers['X-Timezone'] = timezone;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// Add a response interceptor to save the CSRF token from the response
axiosInstance.interceptors.response.use((response) => {
    const csrfToken = response.headers['x-csrftoken'];
    if (csrfToken) {
        document.cookie = `csrftoken=${csrfToken}; path=/`; // Save the CSRF token in cookies
    }
    return response;
}, (error) => {
    return Promise.reject(error);
});
// Function to get a cookie by name
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
        return parts.pop()?.split(';').shift() || null;
    return null;
}
export default axiosInstance;
export { isTokenExpired, refreshAccessToken };
